import { useProducts } from "@/hooks/useProducts";
import ProductCard from "./ProductCard";
import { Timer } from "lucide-react";
import { useState, useEffect } from "react";
import ScrollReveal from "@/components/3d/ScrollReveal";

const DealCarousel = () => {
  const { data: products = [] } = useProducts();
  const deals = products.filter((p) => p.originalPrice && p.originalPrice > p.price).slice(0, 6);

  // Countdown timer — resets every 24 hours
  const [timeLeft, setTimeLeft] = useState("");
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const endOfDay = new Date(now);
      endOfDay.setHours(23, 59, 59, 999);
      const diff = endOfDay.getTime() - now.getTime();
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setTimeLeft(`${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  if (deals.length === 0) return null;

  return (
    <section className="py-10">
      <div className="container mx-auto px-4">
        <ScrollReveal direction="up">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2 rounded-md bg-destructive/20 border border-destructive/30 px-3 py-1.5">
                <Timer className="h-4 w-4 text-destructive" />
                <span className="text-sm font-bold text-destructive">Today's Deals</span>
              </div>
              <span className="font-mono text-sm font-bold text-accent">{timeLeft}</span>
            </div>
            <a href="/shop?sort=price-low" className="text-xs font-medium text-muted-foreground hover:text-primary transition-colors">
              See all deals →
            </a>
          </div>
        </ScrollReveal>
        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
          {deals.map((p, i) => (
            <div key={p.id} className="w-[220px] shrink-0">
              <ProductCard product={p} index={i} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DealCarousel;
